import { PROTOCOL_VERSION, type ClientMsg, type ServerMsg } from '@sunderfen/shared';

/** Anything that carries protocol messages to a world and back. */
export interface Transport {
  onMessage: (m: ServerMsg) => void;
  onClose: (reason: string, kicked: boolean) => void;
  send(m: ClientMsg): void;
  close(): void;
}

/** A WebSocket that speaks the Sunderfen protocol. The server decides everything; this just carries messages. */
export class Connection implements Transport {
  private ws: WebSocket;
  private kicked: string | null = null;
  onMessage: (m: ServerMsg) => void = () => {};
  onClose: (reason: string, kicked: boolean) => void = () => {};

  constructor(url: string, token: string) {
    this.ws = new WebSocket(url);
    this.ws.onopen = () => this.send({ t: 'hello', token, protocol: PROTOCOL_VERSION });
    this.ws.onmessage = e => {
      let m: ServerMsg;
      try { m = JSON.parse(String(e.data)); } catch { return; }
      if (m.t === 'kick') this.kicked = m.reason;
      this.onMessage(m);
    };
    this.ws.onclose = () => this.onClose(this.kicked ?? 'The connection to the world was lost.', this.kicked !== null);
  }
  send(m: ClientMsg) { if (this.ws.readyState === WebSocket.OPEN) this.ws.send(JSON.stringify(m)); }
  close() { this.kicked ??= 'You logged out.'; this.ws.close(); }
}
